import {
    ADDUPDATESUBADMINMGMT_SUCCESS,
    ADDUPDATESUBADMINMGMT_FAILED,
    RESET_ADDUPDATESUBADMINMGMT,
    LOADING_ADDUPDATESUBADMINMGMT,
    NETWORK_ERROR_ADDUPDATESUBADMINMGMT,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminAddUpdateSubAdminMgmt = () => {
    return { type: RESET_ADDUPDATESUBADMINMGMT };
};

const AdminAddUpdateSubAdminMgmt = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATESUBADMINMGMT });
    await adminServices
        .post("addUpdatesubadminMngt", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminAddUpdateSubAdminMgmtsuccess(res.data));
                    break;
                default:
                    dispatch(AdminAddUpdateSubAdminMgmtFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDUPDATESUBADMINMGMT,
                payload: err
            });
        });
};


function AdminAddUpdateSubAdminMgmtsuccess(data) {
    return {
        type: ADDUPDATESUBADMINMGMT_SUCCESS,
        payload: data
    };
}
function AdminAddUpdateSubAdminMgmtFailed(data) {
    return {
        type: ADDUPDATESUBADMINMGMT_FAILED,
        payload: data
    };
}

export { AdminAddUpdateSubAdminMgmt, resetAdminAddUpdateSubAdminMgmt }